import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { HeaderLogoAndTel } from "../../../components/HeaderLogoAndTel";
import { WebDate } from "../../../components/WebDate";
import { GetCourseWidget } from "../../../components/GetCourseWidget";

import * as main from "./style/main.module.scss";
import * as screen1 from "./style/screen1.module.scss";
import * as what from "./style/what.module.scss";
import * as program from "./style/program.module.scss";
import * as reg from "./style/reg.module.scss";
import * as footer from "./style/footer.module.scss";
const Screen1 = ({ id }) => {
  return (
    <header className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel/>

        <div className={screen1.info}>

          <h1>
            Бесплатное онлайн-занятие<br/>
            <span>Как улучшить концентрацию внимания?</span>
          </h1>
          <p className={screen1.desc}>
            Тренинг для тех, кто часто отвлекается и забывает слова
          </p>

          <div className={screen1.date}>
            <WebDate id={id}/>
          </div>

          <div className={screen1.btnBlock}>
            <a href="#registration" className={main.btn}>
              Зарегистрироваться
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};
const What = () => {
  return (
    <section className={what.what}>
      <div className="container">

        <h2 className={main.title}>
          Что такое низкая концентрация и рассеянность в повседневной жизни:
        </h2>

        <div className={what.row}>
          <div className={what.col}>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_uluchshit_koncentraciyu_vnimaniya/ic1.svg" alt=""/>
            <p>
              медленная, прерывистая, скучная речь
            </p>
          </div>
          <div className={what.col}>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_uluchshit_koncentraciyu_vnimaniya/ic2.svg" alt=""/>
            <p>
              мелкие ошибки, раздражающие окружение и влияющие на доход и успеваемость
            </p>
          </div>
          <div className={what.col}>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_uluchshit_koncentraciyu_vnimaniya/ic3.svg" alt=""/>
            <p>
              трата времени на перечитывание, переделывание
            </p>
          </div>
          <div className={what.col}>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_uluchshit_koncentraciyu_vnimaniya/ic4.svg" alt=""/>
            <p>
              постоянная усталость и апатия
            </p>
          </div>
        </div>
        <p className={what.bad}>
          Всё это неизбежно развивается у каждого, кто<br/>перестаёт систематически учиться!
        </p>
        <a href="#registration" className={`${main.btn} ${what.btn}`}>
          Принять участие
        </a>
      </div>
    </section>
  );
};
const Program = () => {
  return (
    <section className={program.program}>
      <div className={`container ${program.container}`}>
        <div className="row">
          <div className={`col-12 ${program.col}`}>
            <h2 className={main.title}>
              На занятии вы:
            </h2>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-6">
            <div className="row">
              <div className={`col-12 ${program.col}`}>
                <span>1</span>
                <p>определите причину вашей рассеянности</p>
              </div>
              <div className={`col-12 ${program.col}`}>
                <span>2</span>
                <p>поймете, как правильно тренировать внимание</p>
              </div>
              <div className={`col-12 ${program.col}`}>
                <span>3</span>
                <p>научитесь работать продуктивно, не допуская утомления и выгорания</p>
              </div>
              <div className={`col-12 ${program.col}`}>
                <span>4</span>
                <p>узнаете, как увеличить скорость речи и перестать забывать слова</p>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-6">
            <div className="row">
              <div className={`col-12 ${program.col}`}>
                <span>5</span>
                <p>получите список из 5 простых упражнений, которые помогут развить интеллектуальную выносливость </p>
              </div>
              <div className={`col-12 ${program.col}`}>
                <span>6</span>
                <p>составите свой алгоритм для борьбы с рассеянностью и повысите концентрацию внимания!</p>
              </div>
              <div className={`col-12 ${program.col}`}>
                <span>7</span>
                <p>получите именной сертификат!</p>
              </div>

            </div>
          </div>
        </div>
        <div className="row">
          <div className={`col-12 ${program.col}`}>
            <a href="#registration" className={`${main.btn} ${program.btn}`}>
              Принять участие
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
const Reg = ({ widget }) => {
  return (
    <section className={reg.reg} id="registration">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-6"></div>
          <div className="col-sm-12 col-md-6">
            <div className={reg.formWrap}>
              { widget }
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};
const Footer = () => {
  return (
    <section className={footer.footer}>
      <div className={`row ${footer.row}`}>
        <div className={`col-md-5 ${footer.col}`}>
          <div className={footer.links}>
            <a href="/about/documents/politika_konfidencialnosti/">Политика конфиденциальности</a>
            <a href="/about/documents/soglashenie_ob_obrabotke_personalnyh_dannyh/">Соглашение об&nbsp;обработке персональных данных</a>
          </div>
        </div>
        <div className={`col-md-5 ${footer.col}`}>
          <div className={footer.socials}>
            <a href="https://vk.com/advanceclub">
              <img src="https://fs.advance.ru/landing-pages/webinar/kak_uluchshit_koncentraciyu_vnimaniya/vk.svg" alt=""/>
            </a>
            <a href="https://www.youtube.com/user/advanceclub?sub_confirmation=1">
              <img src="https://fs.advance.ru/landing-pages/webinar/kak_uluchshit_koncentraciyu_vnimaniya/utube.svg" alt=""/>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

const TITLE = 'Как улучшить концентрацию внимания? Бесплатное онлайн-занятие Advance';
const DESCRIPTION = 'Поможем улучшить концентрацию внимания и забыть о рассеянности в повседневной жизни на нашем бесплатном вебинаре | Центр образовательных технологий Advance. Присоединяйтесь';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = ({ widget=<GetCourseWidget hash={'2cc51c7ccf84878af3657aba80e150b45b9868eb'} id={'254195'}/> }) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1 id={'kukv'}/>
      <What/>
      <Program/>
      <Reg widget={widget}/>
      <Footer/>
    </main>

  </DefaultLayout>
);
export default Page;
